module.exports = __webpack_public_path__ + "img/pants_spec_side_invisible_zipper_length.f9cfd7a1.png";